module.exports = __webpack_public_path__ + "img/counseling-badge.7d3cccf2.png";